import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AiMatchScoreMatchScoreFragmentDoc } from './MatchScore.generated';
export type UserDiagnosisResultV2DiagnosisSummaryFragment = { __typename?: 'DiagnosisSummary', type: Types.DiagnosisType, assetsRank: Types.RankInCluster, householdAnnualIncomeRank: Types.RankInCluster, monthlySavingRank: Types.RankInCluster, cluster: { __typename?: 'DiagnosisCluster', householdStructure: Types.HouseholdStructureType, residentialArea: { __typename?: 'Area', country: string, prefecture?: string | null, city?: string | null, town?: string | null }, statistics: { __typename?: 'DiagnosisClusterStatistics', meanAge: number, meanNumberOfChildren: number, investmentRatio: number, meanHouseholdAnnualIncome: number, meanMonthlySaving: number, meanAssets: number } } };

export type UserDiagnosisResultV2KarteFragment = { __typename?: 'Karte', user: { __typename?: 'User', nickname: string }, diagnosis: { __typename?: 'Diagnosis', uuid: string, annualIncome: number, savingMonth: number, saving: number, investment: number, aiMatchScore?: { __typename?: 'AiMatchScore', lifePlanningMatchingScore: number, onetimeSaleMatchingScore: number, householdImprovementMatchingScore: number, sellingHomeMatchingScore: number, realEstateInvestmentMatchingScore: number, jobChangeMatchingScore: number } | null, partner?: { __typename?: 'DiagnosisPartner', annualIncome: number } | null, diagnosisSummary?: { __typename?: 'DiagnosisSummary', type: Types.DiagnosisType, assetsRank: Types.RankInCluster, householdAnnualIncomeRank: Types.RankInCluster, monthlySavingRank: Types.RankInCluster, cluster: { __typename?: 'DiagnosisCluster', householdStructure: Types.HouseholdStructureType, residentialArea: { __typename?: 'Area', country: string, prefecture?: string | null, city?: string | null, town?: string | null }, statistics: { __typename?: 'DiagnosisClusterStatistics', meanAge: number, meanNumberOfChildren: number, investmentRatio: number, meanHouseholdAnnualIncome: number, meanMonthlySaving: number, meanAssets: number } } } | null } };

export const UserDiagnosisResultV2DiagnosisSummaryFragmentDoc = gql`
    fragment UserDiagnosisResultV2DiagnosisSummary on DiagnosisSummary {
  type
  assetsRank
  householdAnnualIncomeRank
  monthlySavingRank
  cluster {
    residentialArea {
      country
      prefecture
      city
      town
    }
    householdStructure
    statistics {
      meanAge
      meanNumberOfChildren
      investmentRatio
      meanHouseholdAnnualIncome
      meanMonthlySaving
      meanAssets
    }
  }
}
    `;
export const UserDiagnosisResultV2KarteFragmentDoc = gql`
    fragment UserDiagnosisResultV2Karte on Karte {
  user {
    nickname
  }
  diagnosis {
    aiMatchScore {
      ...AiMatchScoreMatchScore
    }
    uuid
    annualIncome
    savingMonth
    saving
    investment
    partner {
      annualIncome
    }
    diagnosisSummary {
      ...UserDiagnosisResultV2DiagnosisSummary
    }
  }
}
    ${AiMatchScoreMatchScoreFragmentDoc}
${UserDiagnosisResultV2DiagnosisSummaryFragmentDoc}`;